// removed by extract-text-webpack-plugin
module.exports = {"spacer":"mobileNav__spacer__f8022b1a","container":"mobileNav__container__f8022b1a","isOpen":"mobileNav__isOpen__f8022b1a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/mobileNav.scss
// module id = ./src/components/MobileNav/mobileNav.scss
// module chunks = 4